export default {
  hebei: {
    // 百度广告联盟
    baiduAd: {
      // 答案页
      answer: false,
      // 知识点
      know: false
    },
    // 腾讯优量汇广告
    TcAd: {
      // 答案页
      answer: true,
      // 知识点
      know: true
    },
    // 红包碎片
    redPieces: true,
    // 首页改版
    homeVersionChange: false,
    // 双十二活动 河北配置成成true  山西false
    doubleEleven: true
  },
  shanxi: {
    // 百度广告联盟
    baiduAd: {
      // 答案页
      answer: false,
      // 知识点
      know: false
    },
    // 腾讯优量汇广告
    TcAd: {
      // 答案页
      answer: true,
      // 知识点
      know: true
    },
    // 红包碎片
    redPieces: false,
    // 首页改版
    homeVersionChange: false,
    // 双十一活动 河北配置成成true  山西false
    doubleEleven: false
  }
}
